<template>
  <div class="container">
    <div ref="wrapper" class="pt-5">
      <HMFileUpload
        class="mb-4"
        v-bind="$attrs"
        :cropper="false"
        :title="title"
        :description="description"
        :value="null"
        inputName="audio-file"
        accept="audio/*"
        @input="addFile"
        @uploading="status => this.$emit('uploading', status)"
      />
    </div>
    <form>
      <HMModalFooter
        :disabled="!file"
        :discardButton="$t('GENERAL.BUTTON.CANCEL')"
        @close="onDiscard"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'HMAudioUploadModal',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    confirm: null,
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    async addFile(file) {
      try {
        await this.confirm(file);
        this.$emit('close');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response, `File upload: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    onConfirm() {
      this.confirm(this.file);
      this.$emit('close');
    },
    onDiscard() {
      if (this.discard) {
        this.discard();
      }
      this.$emit('close');
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
